export const WidthLimitedEllipsedText = {
  maxWidth: '300px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
